import {
  Button,
  danger,
  Input,
  Modal,
  modalHandler,
  ModalOpenBtn,
  success,
  useEffect,
  useState,
} from "@";
import { getGiftProjectAttributes, saveOrderAttribute } from "../api/api";
import type { ReDesignAttributeProps } from "../types";

interface AttributeOption {
  id: number;
  title?: string;
  value?: number;
}

interface OrderState {
  orderItemId?: number;
  attributeId?: number | string;
  giftProjectId?: number;
}

const ReDesignAttribute = ({ row, refetch }: ReDesignAttributeProps) => {
  const [order, setOrder] = useState<OrderState>({});
  const [attributes, setAttributes] = useState<AttributeOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  function handleChange(
    e: React.ChangeEvent<HTMLSelectElement>,
    key: keyof OrderState,
  ) {
    setOrder({ ...order, [key]: e.target.value });
  }

  async function saveData() {
    if (!order.attributeId) {
      danger("يجب اختيار فئة الإهداء");
      return;
    }

    setIsLoading(true);
    try {
      await saveOrderAttribute({
        orderItemId: order.orderItemId as number,
        attributeId: order.attributeId,
      });
      success("تم الحفظ بنجاح");
      modalHandler();
      refetch();
    } catch (error) {
      danger("خطأ  اثناء الحفظ");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchAttributes() {
      try {
        const data = await getGiftProjectAttributes(row.giftProjectId!);
        setAttributes(data);
      } catch (error) {
        danger("خطأ أثناء جلب فئات الاهداء");
      }
    }

    if (row.giftProjectId) {
      fetchAttributes();
    }
    setOrder(row as OrderState);
  }, [row.giftProjectId]);

  return (
    <>
      <ModalOpenBtn hidden />
      <Modal size="max-w-lg" close={() => {}} title="إعادة تصميم الاهداء">
        <main className="p-5">
          <Input
            star
            style="mb-5"
            type="select"
            list={attributes}
            label="فئة الإهداء "
            value={order.attributeId}
            change={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleChange(e, "attributeId")
            }
          />
          <Button
            type="button"
            onClick={saveData}
            isLoading={isLoading}
            title="حفظ البيانات"
          />
        </main>
      </Modal>
    </>
  );
};

export default ReDesignAttribute;
